<!doctype html>
<html lang="en">
  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"auto"}'></div>

        <div data-pdfmake='{"width":"*"}'></div>
      </div>

      <div style="text-align: center; font-size: 16px">
        <div>
          <b>{{ printData?.printReportData?.reportData?.reportName }}</b>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseData?.student?.firstName }}
          {{ printData?.caseData?.student?.lastName }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseData?.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Age</div>
          <div class="dataValue">
            <b> {{ printData?.caseData?.age }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.caseData.student.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.caseData.student.dateOfBirth | date: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Start Date</div>
          <div class="dataValue">
            <b>
              {{
                printData?.printReportData?.reportData?.startDate
                  | userDate: 'MM/dd/yyyy'
              }}</b
            >
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">End Date</div>
          <div class="dataValue">
            <b>{{
              printData?.printReportData?.reportData?.endDate
                | userDate: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'></div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":147}' class="datalabel">
          <b> Comments :</b>
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{ printData?.printReportData?.reportData?.comment || '-' }} </b>
        </div>
      </div>
      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div
        *ngFor="
          let report of printData?.printReportData?.printData;
          let i = index
        ">
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":147}' class="datalabel">
            <b> Category :</b>
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ report.category }} </b>
          </div>
        </div>
        <br />
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":147}' class="datalabel">
            <b> Behavior :</b>
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ report.behavior }} </b>
          </div>
        </div>
        <br />
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":147}' class="datalabel">
            Operational Definition :
          </div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ report.operationalDefinition || 'Nothing Entered' }} </b>
          </div>
        </div>
        <br />
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":147}' class="datalabel">Goals :</div>
          <div data-pdfmake='{"width":"*"}' class="datalabel">
            <b>{{ report.goals || 'Nothing Entered' }} </b>
          </div>
        </div>
        <br />
        <div data-pdfmake='{"width":"*"}'>
          <div *ngFor="let imgSrc of report.graphImage; let i = index">
            <img
              data-pdfmake='{"width":552}'
              [src]="imgSrc"
              [alt]="'Chart Image_' + i"
              class="chartImage" />
          </div>
        </div>
        <br />
        <div data-pdfmake='{"width":"*"}'>
          <div *ngFor="let imgSrc of report.graphTotalImage; let i = index">
            <img
              data-pdfmake='{"width":552}'
              [src]="imgSrc"
              [alt]="'Chart Image_' + i"
              class="chartImage" />
          </div>
        </div>
        <br />
        <div *ngIf="report.commentsData?.length > 0">
          <div class="extraLineHeight">
            <b> Note </b>
            <hr
              data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
            <br />
          </div>
          <ng-container *ngFor="let commentData of report.commentsData">
            <div
              class="extraLineHeight"
              style="font-size: 16px"
              data-pdfmake='{
                "color": "#128E55"}'>
              <b>
                Data Date : {{ commentData.dataDate | date: 'MM/dd/yyyy' }}</b
              >
              <br />
            </div>
            <div *ngFor="let comment of commentData.comments">
              <table
                data-pdfmake='{"widths": ["*"], "heights": 10,"dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
                <tr>
                  <td
                    class="font10"
                    data-pdfmake='{"fillColor": "#F9FAFB","padding": [0,3,0,3]}'>
                    <span class="commentLabel">
                      <b>Note Date : </b>
                      {{ comment.createdOn | userDate: 'MM/dd/yyyy hh:mm a' }}
                      &nbsp;-&nbsp; {{ comment.createdByName }}
                    </span>
                    <br />
                    <span style="color: #101828">{{ comment?.comment }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />
          </ng-container>
        </div>
        <div *ngIf="report.commentsData?.length > 0">
          <div class="extraLineHeight">
            <b> Note </b>
            <hr
              data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
            <br />
          </div>
          <ng-container *ngFor="let commentData of report.commentsData">
            <div
              class="extraLineHeight"
              style="font-size: 16px"
              data-pdfmake='{
                "color": "#128E55"}'>
              <b>
                Data Date : {{ commentData.dataDate | date: 'MM/dd/yyyy' }}</b
              >
              <br />
            </div>
            <div *ngFor="let comment of commentData.comments">
              <table
                data-pdfmake='{"widths": ["*"], "heights": 10,"dontBreakRows": true, "layout": {  "hLineColor": "#eaecf0",  "vLineColor": "#eaecf0"}}'>
                <tr>
                  <td
                    class="font10"
                    data-pdfmake='{"fillColor": "#F9FAFB","padding": [0,3,0,3]}'>
                    <span class="commentLabel">
                      <b>Note Date : </b>
                      {{ comment.createdOn | userDate: 'MM/dd/yyyy hh:mm a' }}
                      &nbsp;-&nbsp; {{ comment.createdByName }}
                    </span>
                    <br />
                    <span style="color: #101828">{{ comment?.comment }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <br />
          </ng-container>
        </div>
        <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      </div>
    </div>
  </body>
</html>
